/* tslint:disable */
/* eslint-disable */
/**
 * Generic Recon Service
 * A comprehensive generic recon service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Request model for AgentCore webhook callback from Bedrock AgentCore. Includes success status and optional callback metrics from the agent.
 */
export interface AgentCoreWebhookCallbackRequest {
    /**
     * Whether the job processing was successful
     */
    'success': boolean;
    'error_message'?: string | null;
    'metrics'?: object | null;
}
/**
 * Enumeration for job perspective values.
 */

export const AppModelsDomainModelsJobsPerspective = {
    Customer: 'customer',
    Vendor: 'vendor',
} as const;

export type AppModelsDomainModelsJobsPerspective = typeof AppModelsDomainModelsJobsPerspective[keyof typeof AppModelsDomainModelsJobsPerspective];


/**
 * Model for balance information with opening and closing balances.
 */
export interface BalanceInfo {
    'opening'?: number | null;
    'closing'?: number | null;
}
/**
 * Model for balances containing our balance and their balance.
 */
export interface Balances {
    'our_balance'?: BalanceInfo | null;
    'their_balance'?: BalanceInfo | null;
}
/**
 * Request model for creating a bank_recon job. Input files must have keys \'bank\' and \'ledger\'. Start_date, end_date, entity_name are required.
 */
export interface BankReconCreateJobRequest {
    /**
     * Input files with keys \'bank\' and \'ledger\'
     */
    'input_files': BankReconInputFiles;
    /**
     * Start date
     */
    'start_date': string;
    /**
     * End date
     */
    'end_date': string;
    /**
     * Entity name for entity-specific instructions
     */
    'entity_name': string;
    'name'?: string | null;
    'description'?: string | null;
    'instructions'?: string | null;
    'created_by'?: string | null;
}
/**
 * Input files for bank_recon: must have keys \'bank\' and \'ledger\'.
 */
export interface BankReconInputFiles {
    /**
     * List of filenames for bank statement
     */
    'bank': Array<string>;
    /**
     * List of filenames for ledger
     */
    'ledger': Array<string>;
}
/**
 * Request model for cancelling a job.
 */
export interface CancelJobRequest {
    'cancelled_by'?: string | null;
}

export const ClientsMemoryApiModelsPerspective = {
    Customer: 'customer',
    Vendor: 'vendor',
} as const;

export type ClientsMemoryApiModelsPerspective = typeof ClientsMemoryApiModelsPerspective[keyof typeof ClientsMemoryApiModelsPerspective];


/**
 * Request model for creating customer instructions.
 */
export interface CreateCustomerRequest {
    /**
     * Customer identifier for the new record
     */
    'customer_id': string;
    /**
     * Username for audit and instruction attribution
     */
    'username': string;
    /**
     * Reconciliation type
     */
    'recon_type': JobType;
    'instructions'?: string | null;
    'instructions_description'?: string | null;
}


/**
 * Request model for creating a new entity instruction version.
 */
export interface CreateEntityInstructionVersionRequest {
    'instructions'?: string | null;
    'description'?: string | null;
}
/**
 * Request model for creating an entity.  `name` is the party name passed straight through to CDS for resolution. `counter_party_type` is required only for `ledger_recon` — for `pg_recon` and `bank_recon` it must be absent (those parties have no counter-party concept).
 */
export interface CreateEntityRequest {
    /**
     * Party name passed to CDS for find-or-create
     */
    'name': string;
    /**
     * Reconciliation type
     */
    'recon_type': JobType;
    'counter_party_type'?: AppModelsDomainModelsJobsPerspective | null;
    'instructions'?: string | null;
    'instructions_description'?: string | null;
}


/**
 * Request model for creating a new instruction version.
 */
export interface CreateInstructionVersionRequest {
    'instructions'?: string | null;
    'description'?: string | null;
    'entity_id'?: string | null;
}
/**
 * Request model for creating a new reconciliation job. Input files are organized by category (e.g., ledger, bank).
 */
export interface CreateJobRequest {
    /**
     * Job type
     */
    'type': JobType;
    /**
     * Input files organized by category (e.g., {\'ledger\': [\'file1.csv\'], \'bank\': [\'bank1.csv\']})
     */
    'input_files': { [key: string]: Array<string>; };
    'name'?: string | null;
    'start_date'?: string | null;
    'end_date'?: string | null;
    'description'?: string | null;
    'instructions'?: string | null;
    'created_by'?: string | null;
    /**
     * Entity name for entity-specific instructions
     */
    'entity_name': string;
    'perspective'?: AppModelsDomainModelsJobsPerspective | null;
    'balances'?: Balances | null;
    'workflow_reference'?: WorkflowReference | null;
}


/**
 * Response model for job creation. Presigned URLs are organized by category matching the input_files structure.
 */
export interface CreateJobResponse {
    /**
     * Job identifier
     */
    'id': string;
    /**
     * Customer identifier
     */
    'customer_id': string;
    /**
     * Reconciliation type name
     */
    'type': JobType;
    /**
     * Job status
     */
    'status': JobStatus;
    /**
     * Job creation timestamp
     */
    'created_at': string;
    /**
     * Presigned URLs organized by category matching input_files structure
     */
    'presigned_urls': { [key: string]: Array<PresignedFileInfo>; };
    'job_metadata'?: object | null;
    /**
     * Entity name
     */
    'entity_name': string;
    /**
     * Job instructions
     */
    'instructions': string;
    'perspective'?: PerspectiveOutput | null;
    'reference'?: WorkflowReference | null;
}


/**
 * Request model for creating a new type.
 */
export interface CreateTypeRequest {
    'name': string;
    'description'?: string | null;
    'expected_output_files'?: ExpectedOutputFiles | null;
    'file_upload_layout'?: object | null;
    'dashboard_items'?: Array<object> | null;
    'entities'?: string | null;
    'column_order'?: Array<string> | null;
    'column_mapping'?: object | null;
    'sources'?: Array<string> | null;
    'source_sheet_columns'?: object | null;
}
/**
 * Domain model for Customer entity.
 */
export interface Customer {
    'id': string;
    'customer_id': string;
    'recon_type': JobType;
    'instructions'?: string | null;
    'created_at': string;
    'updated_at': string;
}


/**
 * Domain model for a single versioned instruction record.
 */
export interface CustomerInstruction {
    'id': string;
    'customer_id': string;
    'entity_id'?: string | null;
    'recon_type': JobType;
    'description'?: string | null;
    'instructions'?: string | null;
    'version_number': number;
    'is_active': boolean;
    'is_deleted': boolean;
    'metadata'?: object | null;
    'created_at': string;
    'updated_at': string;
}


/**
 * Rich response returned by GET /versioned-instructions. Includes the requested version\'s data plus a summary of all available versions.
 */
export interface CustomerInstructionsResponse {
    'id': string;
    'customer_id': string;
    'recon_type': JobType;
    'entity_id'?: string | null;
    'instructions'?: string | null;
    'active_instructions_version'?: number | null;
    'selected_version_number': number;
    'total_instructions_versions': number;
    'available_versions': Array<VersionSummary>;
    'created_at': string;
    'updated_at': string;
}


/**
 * Request model for soft-deleting a specific version.
 */
export interface DeleteInstructionVersionRequest {
    /**
     * Version number to delete
     */
    'version_number': number;
}
/**
 * Request model for soft-deleting a job.
 */
export interface DeleteJobRequest {
    'deleted_by'?: string | null;
}
export interface DeleteLearningRequest {
    'agent_name': string;
    'recon_type': ReconType;
    'counterparty_name': string;
    'perspective': ClientsMemoryApiModelsPerspective;
    /**
     * One or more learning types to soft-delete
     */
    'learning_types': Array<string>;
}


export interface DeleteLearningResponse {
    'success': boolean;
    /**
     * Number of records actually updated
     */
    'deleted_count': number;
    'message': string;
}
/**
 * Request model for editing an existing type.
 */
export interface EditTypeRequest {
    'name'?: string | null;
    'description'?: string | null;
    'expected_output_files'?: ExpectedOutputFiles | null;
    'file_upload_layout'?: object | null;
    'dashboard_items'?: Array<object> | null;
    'entities'?: string | null;
    'column_order'?: Array<string> | null;
    'column_mapping'?: object | null;
    'sources'?: Array<string> | null;
    'source_sheet_columns'?: object | null;
}
/**
 * Domain model for a party entity.  `id` holds the CDS `parties_v2.id` UUID directly — there is no separate local identifier after the entities table removal.  `is_deleted`, `created_at`, and `updated_at` are populated from CDS party data where available; they default to safe values for callers that do not need them (e.g. listing responses backed by the FDW).
 */
export interface Entity {
    'id': string;
    'customer_id': string;
    'entity_name': string;
    'recon_type': JobType;
    'instructions'?: string | null;
    'is_deleted'?: boolean;
    'created_at': string;
    'updated_at': string;
    'latest_job_start_date'?: string | null;
    'latest_job_end_date'?: string | null;
    'latest_job_created_at'?: string | null;
    /**
     * Number of completed jobs for this entity
     */
    'completed_jobs_count'?: number;
    /**
     * Number of processing jobs for this entity
     */
    'processing_jobs_count'?: number;
    'counter_party_type'?: PerspectiveOutput | null;
}


/**
 * Domain model for entity instructions.
 */
export interface EntityInstructions {
    'id': string;
    'customer_id': string;
    'entity_name': string;
    'recon_type': JobType;
    'instructions'?: string | null;
    'is_deleted'?: boolean;
    'created_at': string;
    'updated_at': string;
    /**
     * Currently active instruction version number
     */
    'active_instructions_version'?: number;
    /**
     * Selected instruction version number
     */
    'selected_version_number'?: number;
    /**
     * Total number of instruction versions
     */
    'total_instructions_versions'?: number;
    /**
     * List of all available instruction versions
     */
    'available_versions'?: Array<VersionSummary>;
}


/**
 * Response model for Excel report generation. Returns a presigned download URL instead of the file bytes.
 */
export interface ExcelReportResponse {
    /**
     * Presigned URL to download the Excel report
     */
    'download_url': string;
    /**
     * Suggested filename for the report (e.g. reconciliation_report_<job_id>.xlsx)
     */
    'filename': string;
    'expires_in_seconds'?: number | null;
}
/**
 * Describes the output files a job type is expected to produce.  compulsory: files whose absence should fail webhook processing. optional: files that may or may not be present without affecting processing.
 */
export interface ExpectedOutputFiles {
    'compulsory'?: Array<string>;
    'optional'?: Array<string>;
}
/**
 * Per-category list of S3 file refs for copying input files from an external bucket. Used when files already exist elsewhere (e.g. another service\'s S3) and must be copied into this service\'s bucket. An empty list for a category means no files to copy for that side; presigned upload URLs will be generated instead.
 */
export interface ExternalFilesCopySpec {
    /**
     * List of file refs (s3_key, filename) for \'our\' category; empty means generate presigned URL for this side
     */
    'our'?: Array<S3FileRef>;
    /**
     * List of file refs (s3_key, filename) for \'their\' category; empty means generate presigned URL for this side
     */
    'their'?: Array<S3FileRef>;
}
export interface GetLearningsResponseValue {
    'learning_id': string;
    'learning_data': object;
    'confidence': number;
    'notes'?: string | null;
    'timestamp': string;
    /**
     * Match category (e.g. exact)
     */
    'match_type': string;
    'retrieval_note': string;
}
export interface HTTPValidationError {
    'detail'?: Array<ValidationError>;
}
/**
 * Describes how input files are provided: optional workflow context and optional copy-from-external-S3 spec. - reference: id and workflow type stored in job_metadata (e.g. balance_confirmation). - bucket + external_files: when both set, input files are copied from that bucket into the service bucket (no client upload).
 */
export interface InputFilesSource {
    'reference'?: WorkflowReference | null;
    'bucket'?: string | null;
    'external_files'?: ExternalFilesCopySpec | null;
}
/**
 * Domain model for Job entity. POST_PROCESSING is an internal state used during webhook processing. When returned to clients, it should be normalized to PROCESSING.
 */
export interface Job {
    'id': string;
    'customer_id': string;
    'type': JobType;
    'status': string;
    'infra_metadata'?: object | null;
    'job_metadata'?: object | null;
    'created_at': string;
    'updated_at': string;
    'entity_name'?: string;
    'entity_id'?: string | null;
    'deleted'?: boolean;
    'instructions'?: string | null;
    'perspective'?: PerspectiveOutput | null;
    'balances'?: Balances | null;
}


/**
 * Customer-level quota usage for a single recon type.
 */
export interface JobQuotaResponse {
    /**
     * Reconciliation type the quota applies to
     */
    'type': JobType;
    /**
     * Completed jobs of this recon type for the customer (soft-deleted completed jobs still count)
     */
    'used': number;
}


/**
 * Enumeration for job status values.
 */

export const JobStatus = {
    Created: 'created',
    Processing: 'processing',
    Running: 'running',
    PostProcessing: 'post_processing',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled',
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];


/**
 * Response model for job report.
 */
export interface JobSummaryResponse {
    /**
     * Job identifier
     */
    'id': string;
    /**
     * Customer identifier
     */
    'customer_id': string;
    /**
     * Job status
     */
    'status': string;
    'files'?: object | null;
    'metrics'?: object | null;
    /**
     * Job
     */
    'job': Job;
}
/**
 * Enumeration for job type values.
 */

export const JobType = {
    BankRecon: 'bank_recon',
    LedgerRecon: 'ledger_recon',
    PgRecon: 'pg_recon',
} as const;

export type JobType = typeof JobType[keyof typeof JobType];


export interface Learning {
    'learning_id': string;
    'learning_data': object;
    'confidence': number;
    'notes'?: string | null;
    'timestamp': string;
    /**
     * Match category (e.g. exact)
     */
    'match_type': string;
    'retrieval_note': string;
}
/**
 * Request model for creating a ledger_recon job. Input files can be provided in two ways: - Client upload: set input_files (our/their list of filenames); client uploads via presigned URLs. - Copy from external: set workflow_reference.bucket and workflow_reference.external_files; files are copied from that bucket (e.g. balance confirmation flow). Perspective, start_date, end_date, entity_name are required.
 */
export interface LedgerReconCreateJobRequest {
    'input_files'?: LedgerReconInputFiles | null;
    /**
     * Perspective for the job (customer or vendor)
     */
    'perspective': AppModelsDomainModelsJobsPerspective;
    /**
     * Start date
     */
    'start_date': string;
    /**
     * End date
     */
    'end_date': string;
    /**
     * Entity name for entity-specific instructions
     */
    'entity_name': string;
    'name'?: string | null;
    'description'?: string | null;
    'instructions'?: string | null;
    'created_by'?: string | null;
    'balances'?: Balances | null;
    'workflow_reference'?: InputFilesSource | null;
}


/**
 * Input files for ledger_recon: must have keys \'our\' and \'their\'. In mixed mode (with workflow_reference.external_files), a category may be empty when the corresponding external_files list is non-empty (those files are copied instead of uploaded).
 */
export interface LedgerReconInputFiles {
    /**
     * List of filenames for \'our\' ledger
     */
    'our'?: Array<string>;
    /**
     * List of filenames for \'their\' ledger
     */
    'their'?: Array<string>;
}
export interface LocationInner {
}
/**
 * Request model for marking a specific version as active.
 */
export interface MarkVersionActiveRequest {
    /**
     * Version number to activate
     */
    'version_number': number;
}
/**
 * Paginated response model for entities list.
 */
export interface PaginatedEntitiesResponse {
    /**
     * List of entities
     */
    'data': Array<Entity>;
    /**
     * Total number of entities
     */
    'total': number;
    /**
     * Current page number
     */
    'page': number;
    /**
     * Total number of pages
     */
    'total_pages': number;
    /**
     * Number of items per page
     */
    'limit': number;
}
/**
 * Paginated response model for jobs list.
 */
export interface PaginatedJobsResponse {
    /**
     * List of jobs
     */
    'data': Array<Job>;
    /**
     * Total number of jobs
     */
    'total': number;
    /**
     * Current page number
     */
    'page': number;
    /**
     * Total number of pages
     */
    'total_pages': number;
    /**
     * Number of items per page
     */
    'limit': number;
}
/**
 * Paginated response model for types list.
 */
export interface PaginatedTypesResponse {
    /**
     * List of types
     */
    'data': Array<Type>;
    /**
     * Total number of types
     */
    'total': number;
    /**
     * Current page number
     */
    'page': number;
    /**
     * Total number of pages
     */
    'total_pages': number;
    /**
     * Number of items per page
     */
    'limit': number;
}
/**
 * Enumeration for job perspective values.
 */

export const PerspectiveOutput = {
    Customer: 'customer',
    Vendor: 'vendor',
} as const;

export type PerspectiveOutput = typeof PerspectiveOutput[keyof typeof PerspectiveOutput];


/**
 * Request model for creating a pg_recon job. Input files must have keys \'pg_report\' and \'ledger\'. Start_date, end_date, entity_name are required.
 */
export interface PgReconCreateJobRequest {
    /**
     * Input files with keys \'pg_report\' and \'ledger\'
     */
    'input_files': PgReconInputFiles;
    /**
     * Start date
     */
    'start_date': string;
    /**
     * End date
     */
    'end_date': string;
    /**
     * Entity name for entity-specific instructions
     */
    'entity_name': string;
    /**
     * Job name
     */
    'name': string;
    'description'?: string | null;
    'instructions'?: string | null;
    'created_by'?: string | null;
}
/**
 * Input files for pg_recon: must have keys \'pg_report\' and \'ledger\'.
 */
export interface PgReconInputFiles {
    /**
     * List of filenames for PG report
     */
    'pg_report': Array<string>;
    /**
     * List of filenames for ledger
     */
    'ledger': Array<string>;
}
/**
 * Enumeration for transaction debit/credit values.
 */

export const Polarity = {
    Credit: 'credit',
    Debit: 'debit',
} as const;

export type Polarity = typeof Polarity[keyof typeof Polarity];


/**
 * Model for presigned file information in response.
 */
export interface PresignedFileInfo {
    /**
     * Original filename
     */
    'filename': string;
    /**
     * Presigned URL for file upload
     */
    'presigned_url': string;
}

export const ReconType = {
    BankRecon: 'bank_recon',
    LedgerRecon: 'ledger_recon',
    PgRecon: 'pg_recon',
} as const;

export type ReconType = typeof ReconType[keyof typeof ReconType];


/**
 * Request model for retrying a job.
 */
export interface RetryJobRequest {
    'instructions'?: string | null;
    'requested_by'?: string | null;
    'start_date'?: string | null;
    'end_date'?: string | null;
    'name'?: string | null;
    'skip_processing'?: boolean | null;
    'perspective'?: AppModelsDomainModelsJobsPerspective | null;
    'retry_type'?: RetryType | null;
    'balances'?: Balances | null;
}


/**
 * Enumeration for retry type values.
 */

export const RetryType = {
    Normal: 'normal',
    Quick: 'quick',
} as const;

export type RetryType = typeof RetryType[keyof typeof RetryType];


/**
 * Single file reference when copying from an external S3 location: s3_key in source bucket and filename for destination key / job_metadata.
 */
export interface S3FileRef {
    /**
     * S3 key of the file in the source bucket
     */
    's3_key': string;
    /**
     * Filename used for destination key and job_metadata
     */
    'filename': string;
}
export interface StoreLearningRequest {
    'agent_name': string;
    'recon_type': ReconType;
    'counterparty_name': string;
    'perspective': ClientsMemoryApiModelsPerspective;
    'learning_type': string;
    'learning_data': object;
    'confidence': number;
    'notes'?: string | null;
    'pattern_scope'?: string | null;
    'attributes'?: object | null;
}


export interface StoreLearningResponse {
    'success': boolean;
    'learning_id': string;
    'message': string;
}
/**
 * Response model for a single transaction.
 */
export interface TransactionResponse {
    'id': string;
    'transaction_id': string;
    'job_id': string;
    'customer_id': string;
    'version_number': number;
    'match_id'?: string | null;
    'source'?: string | null;
    'date'?: string | null;
    'amount'?: number | null;
    'reference'?: string | null;
    'party_name'?: string | null;
    'description'?: string | null;
    'updated_by'?: string | null;
    'polarity'?: Polarity | null;
    'transaction_type'?: string | null;
    'narration'?: string | null;
    'allocated_amount'?: number | null;
    'additional_property_1'?: string | null;
    'additional_property_2'?: string | null;
    'additional_property_3'?: string | null;
    'additional_property_4'?: string | null;
    'additional_property_5'?: string | null;
    'is_deleted': boolean;
    'created_at': string;
    'updated_at': string;
}


/**
 * Model for a single transaction update.
 */
export interface TransactionUpdate {
    /**
     * Transaction ID
     */
    'transaction_id': string;
    'match_id'?: string | null;
    /**
     * Updated by (username)
     */
    'updated_by': string;
    'description'?: string | null;
}
/**
 * Domain model for Type entity.
 */
export interface Type {
    'id': string;
    'name': string;
    'description'?: string | null;
    'metadata'?: object | null;
    'created_at': string;
    'updated_at': string;
}
/**
 * Request model for updating recon summary.
 */
export interface UpdateReconSummaryRequest {
    /**
     * Reconciliation metrics to update
     */
    'metrics': object;
}
/**
 * Request model for updating transactions.
 */
export interface UpdateTransactionsRequest {
    /**
     * List of transaction updates
     */
    'updates': Array<TransactionUpdate>;
}
/**
 * Response model for transaction update.
 */
export interface UpdateTransactionsResponse {
    /**
     * List of transactions that were updated
     */
    'updated_transactions': Array<TransactionResponse>;
}
export interface ValidationError {
    'loc': Array<LocationInner>;
    'msg': string;
    'type': string;
    'input'?: any;
    'ctx'?: object;
}
/**
 * Lightweight version entry used in list responses.
 */
export interface VersionSummary {
    'version_number': number;
    'description'?: string | null;
    'created_at'?: string | null;
}
/**
 * Response model for webhook endpoints
 */
export interface WebhookResponse {
    'message': string;
    'received_data': any;
    'timestamp': string;
}
/**
 * Reference ID and workflow type stored in job_metadata. Used when the job was created from a specific workflow (e.g. balance confirmation, future flows).
 */
export interface WorkflowReference {
    'id'?: string | null;
    'workflow'?: WorkflowType | null;
}


/**
 * Enumeration for workflow/source type stored in job_metadata (e.g. balance_confirmation).
 */

export const WorkflowType = {
    BalanceConfirmation: 'balance_confirmation',
} as const;

export type WorkflowType = typeof WorkflowType[keyof typeof WorkflowType];



/**
 * CustomersApi - axios parameter creator
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a customer record for a given recon_type.
         * @summary Create Customer
         * @param {CreateCustomerRequest} createCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerApiV1CustomersPost: async (createCustomerRequest: CreateCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomerRequest' is not null or undefined
            assertParamExists('createCustomerApiV1CustomersPost', 'createCustomerRequest', createCustomerRequest)
            const localVarPath = `/api/v1/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a specific version (sets is_deleted=True). The currently active version cannot be deleted.
         * @summary Delete an Instruction Version
         * @param {JobType} reconType 
         * @param {DeleteInstructionVersionRequest} deleteInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost: async (reconType: JobType, deleteInstructionVersionRequest: DeleteInstructionVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reconType' is not null or undefined
            assertParamExists('deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost', 'reconType', reconType)
            // verify required parameter 'deleteInstructionVersionRequest' is not null or undefined
            assertParamExists('deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost', 'deleteInstructionVersionRequest', deleteInstructionVersionRequest)
            const localVarPath = `/api/v1/customers/recon-type/{recon_type}/instructions/delete`
                .replace(`{${"recon_type"}}`, encodeURIComponent(String(reconType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteInstructionVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get instructions for the authenticated customer and recon_type. Omit version_number to get the active version.
         * @summary Get Instructions
         * @param {JobType} reconType Reconciliation type
         * @param {number} [versionNumber] Specific version to retrieve; defaults to the active version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstructionsApiV1CustomersInstructionsGet: async (reconType: JobType, versionNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reconType' is not null or undefined
            assertParamExists('getInstructionsApiV1CustomersInstructionsGet', 'reconType', reconType)
            const localVarPath = `/api/v1/customers/instructions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reconType !== undefined) {
                localVarQueryParameter['recon_type'] = reconType;
            }

            if (versionNumber !== undefined) {
                localVarQueryParameter['version_number'] = versionNumber;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activate a specific instruction version. The previously active version is automatically deactivated.
         * @summary Mark a Version as Active
         * @param {JobType} reconType 
         * @param {MarkVersionActiveRequest} markVersionActiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost: async (reconType: JobType, markVersionActiveRequest: MarkVersionActiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reconType' is not null or undefined
            assertParamExists('markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost', 'reconType', reconType)
            // verify required parameter 'markVersionActiveRequest' is not null or undefined
            assertParamExists('markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost', 'markVersionActiveRequest', markVersionActiveRequest)
            const localVarPath = `/api/v1/customers/recon-type/{recon_type}/instructions/activate`
                .replace(`{${"recon_type"}}`, encodeURIComponent(String(reconType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markVersionActiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new instruction version. Version numbers are assigned automatically.
         * @summary Update Instructions
         * @param {JobType} reconType 
         * @param {CreateInstructionVersionRequest} createInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost: async (reconType: JobType, createInstructionVersionRequest: CreateInstructionVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reconType' is not null or undefined
            assertParamExists('updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost', 'reconType', reconType)
            // verify required parameter 'createInstructionVersionRequest' is not null or undefined
            assertParamExists('updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost', 'createInstructionVersionRequest', createInstructionVersionRequest)
            const localVarPath = `/api/v1/customers/recon-type/{recon_type}/instructions/update`
                .replace(`{${"recon_type"}}`, encodeURIComponent(String(reconType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInstructionVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a customer record for a given recon_type.
         * @summary Create Customer
         * @param {CreateCustomerRequest} createCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerApiV1CustomersPost(createCustomerRequest: CreateCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerApiV1CustomersPost(createCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.createCustomerApiV1CustomersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete a specific version (sets is_deleted=True). The currently active version cannot be deleted.
         * @summary Delete an Instruction Version
         * @param {JobType} reconType 
         * @param {DeleteInstructionVersionRequest} deleteInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost(reconType: JobType, deleteInstructionVersionRequest: DeleteInstructionVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstruction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost(reconType, deleteInstructionVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get instructions for the authenticated customer and recon_type. Omit version_number to get the active version.
         * @summary Get Instructions
         * @param {JobType} reconType Reconciliation type
         * @param {number} [versionNumber] Specific version to retrieve; defaults to the active version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstructionsApiV1CustomersInstructionsGet(reconType: JobType, versionNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstructionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstructionsApiV1CustomersInstructionsGet(reconType, versionNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getInstructionsApiV1CustomersInstructionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Activate a specific instruction version. The previously active version is automatically deactivated.
         * @summary Mark a Version as Active
         * @param {JobType} reconType 
         * @param {MarkVersionActiveRequest} markVersionActiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost(reconType: JobType, markVersionActiveRequest: MarkVersionActiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstruction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost(reconType, markVersionActiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new instruction version. Version numbers are assigned automatically.
         * @summary Update Instructions
         * @param {JobType} reconType 
         * @param {CreateInstructionVersionRequest} createInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost(reconType: JobType, createInstructionVersionRequest: CreateInstructionVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstruction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost(reconType, createInstructionVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * Create a customer record for a given recon_type.
         * @summary Create Customer
         * @param {CustomersApiCreateCustomerApiV1CustomersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerApiV1CustomersPost(requestParameters: CustomersApiCreateCustomerApiV1CustomersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Customer> {
            return localVarFp.createCustomerApiV1CustomersPost(requestParameters.createCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a specific version (sets is_deleted=True). The currently active version cannot be deleted.
         * @summary Delete an Instruction Version
         * @param {CustomersApiDeleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost(requestParameters: CustomersApiDeleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstruction> {
            return localVarFp.deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost(requestParameters.reconType, requestParameters.deleteInstructionVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get instructions for the authenticated customer and recon_type. Omit version_number to get the active version.
         * @summary Get Instructions
         * @param {CustomersApiGetInstructionsApiV1CustomersInstructionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstructionsApiV1CustomersInstructionsGet(requestParameters: CustomersApiGetInstructionsApiV1CustomersInstructionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstructionsResponse> {
            return localVarFp.getInstructionsApiV1CustomersInstructionsGet(requestParameters.reconType, requestParameters.versionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Activate a specific instruction version. The previously active version is automatically deactivated.
         * @summary Mark a Version as Active
         * @param {CustomersApiMarkInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost(requestParameters: CustomersApiMarkInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstruction> {
            return localVarFp.markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost(requestParameters.reconType, requestParameters.markVersionActiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new instruction version. Version numbers are assigned automatically.
         * @summary Update Instructions
         * @param {CustomersApiUpdateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost(requestParameters: CustomersApiUpdateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstruction> {
            return localVarFp.updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost(requestParameters.reconType, requestParameters.createInstructionVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCustomerApiV1CustomersPost operation in CustomersApi.
 */
export interface CustomersApiCreateCustomerApiV1CustomersPostRequest {
    readonly createCustomerRequest: CreateCustomerRequest
}

/**
 * Request parameters for deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost operation in CustomersApi.
 */
export interface CustomersApiDeleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePostRequest {
    readonly reconType: JobType

    readonly deleteInstructionVersionRequest: DeleteInstructionVersionRequest
}

/**
 * Request parameters for getInstructionsApiV1CustomersInstructionsGet operation in CustomersApi.
 */
export interface CustomersApiGetInstructionsApiV1CustomersInstructionsGetRequest {
    /**
     * Reconciliation type
     */
    readonly reconType: JobType

    /**
     * Specific version to retrieve; defaults to the active version
     */
    readonly versionNumber?: number
}

/**
 * Request parameters for markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost operation in CustomersApi.
 */
export interface CustomersApiMarkInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePostRequest {
    readonly reconType: JobType

    readonly markVersionActiveRequest: MarkVersionActiveRequest
}

/**
 * Request parameters for updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost operation in CustomersApi.
 */
export interface CustomersApiUpdateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePostRequest {
    readonly reconType: JobType

    readonly createInstructionVersionRequest: CreateInstructionVersionRequest
}

/**
 * CustomersApi - object-oriented interface
 */
export class CustomersApi extends BaseAPI {
    /**
     * Create a customer record for a given recon_type.
     * @summary Create Customer
     * @param {CustomersApiCreateCustomerApiV1CustomersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCustomerApiV1CustomersPost(requestParameters: CustomersApiCreateCustomerApiV1CustomersPostRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).createCustomerApiV1CustomersPost(requestParameters.createCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a specific version (sets is_deleted=True). The currently active version cannot be deleted.
     * @summary Delete an Instruction Version
     * @param {CustomersApiDeleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost(requestParameters: CustomersApiDeleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePostRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).deleteInstructionVersionApiV1CustomersReconTypeReconTypeInstructionsDeletePost(requestParameters.reconType, requestParameters.deleteInstructionVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get instructions for the authenticated customer and recon_type. Omit version_number to get the active version.
     * @summary Get Instructions
     * @param {CustomersApiGetInstructionsApiV1CustomersInstructionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInstructionsApiV1CustomersInstructionsGet(requestParameters: CustomersApiGetInstructionsApiV1CustomersInstructionsGetRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getInstructionsApiV1CustomersInstructionsGet(requestParameters.reconType, requestParameters.versionNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activate a specific instruction version. The previously active version is automatically deactivated.
     * @summary Mark a Version as Active
     * @param {CustomersApiMarkInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost(requestParameters: CustomersApiMarkInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePostRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).markInstructionVersionActiveApiV1CustomersReconTypeReconTypeInstructionsActivatePost(requestParameters.reconType, requestParameters.markVersionActiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new instruction version. Version numbers are assigned automatically.
     * @summary Update Instructions
     * @param {CustomersApiUpdateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost(requestParameters: CustomersApiUpdateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateInstructionsApiV1CustomersReconTypeReconTypeInstructionsUpdatePost(requestParameters.reconType, requestParameters.createInstructionVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthCheckHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Health check endpoint
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckHealthGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * Health check endpoint
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthCheckHealthGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthCheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntitiesApi - axios parameter creator
 */
export const EntitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an entity by resolving (or creating) the corresponding CDS party. For `ledger_recon`, `counter_party_type` is required; for `pg_recon` and `bank_recon` it must be omitted.
         * @summary Create Entity (CDS find-or-create)
         * @param {CreateEntityRequest} createEntityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiV1EntitiesPost: async (createEntityRequest: CreateEntityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEntityRequest' is not null or undefined
            assertParamExists('createEntityApiV1EntitiesPost', 'createEntityRequest', createEntityRequest)
            const localVarPath = `/api/v1/entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEntityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete an entity by setting is_deleted=True
         * @summary Soft Delete Entity
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiV1EntitiesEntityIdDeletePost: async (entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteEntityApiV1EntitiesEntityIdDeletePost', 'entityId', entityId)
            const localVarPath = `/api/v1/entities/{entity_id}/delete`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a specific entity instruction version (sets is_deleted=True). The currently active version cannot be deleted.
         * @summary Delete an Entity Instruction Version
         * @param {string} entityId 
         * @param {DeleteInstructionVersionRequest} deleteInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost: async (entityId: string, deleteInstructionVersionRequest: DeleteInstructionVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost', 'entityId', entityId)
            // verify required parameter 'deleteInstructionVersionRequest' is not null or undefined
            assertParamExists('deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost', 'deleteInstructionVersionRequest', deleteInstructionVersionRequest)
            const localVarPath = `/api/v1/entities/{entity_id}/instructions/delete`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteInstructionVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get entities with pagination, filtering, and search. Each row is enriched with its resolved CDS party identity.
         * @summary Get Entities
         * @param {JobType} type Reconciliation type
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Number of entities per page
         * @param {string | null} [id] Entity ID
         * @param {string | null} [search] Search term forwarded to CDS (CDS-first)
         * @param {AppModelsDomainModelsJobsPerspective | null} [counterPartyType] Filter by counter-party type (ledger_recon only).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitiesApiV1EntitiesGet: async (type: JobType, page?: number, limit?: number, id?: string | null, search?: string | null, counterPartyType?: AppModelsDomainModelsJobsPerspective | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getEntitiesApiV1EntitiesGet', 'type', type)
            const localVarPath = `/api/v1/entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (counterPartyType !== undefined) {
                localVarQueryParameter['counter_party_type'] = counterPartyType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a single entity by ID, enriched with the resolved CDS party identity.
         * @summary Get Entity by ID
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiV1EntitiesEntityIdGet: async (entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityApiV1EntitiesEntityIdGet', 'entityId', entityId)
            const localVarPath = `/api/v1/entities/{entity_id}`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the active (or specific) instruction version for an entity addressed by ID.
         * @summary Get Entity Instructions by ID
         * @param {string} entityId 
         * @param {number | null} [versionNumber] Instruction version number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet: async (entityId: string, versionNumber?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet', 'entityId', entityId)
            const localVarPath = `/api/v1/entities/{entity_id}/instructions`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (versionNumber !== undefined) {
                localVarQueryParameter['version_number'] = versionNumber;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activate a specific entity instruction version. The previously active version is automatically deactivated.
         * @summary Mark Entity Instruction Version as Active
         * @param {string} entityId 
         * @param {MarkVersionActiveRequest} markVersionActiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost: async (entityId: string, markVersionActiveRequest: MarkVersionActiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost', 'entityId', entityId)
            // verify required parameter 'markVersionActiveRequest' is not null or undefined
            assertParamExists('markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost', 'markVersionActiveRequest', markVersionActiveRequest)
            const localVarPath = `/api/v1/entities/{entity_id}/instructions/activate`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markVersionActiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new entity instruction version. Version numbers are assigned automatically.
         * @summary Update Entity Instructions
         * @param {string} entityId 
         * @param {CreateEntityInstructionVersionRequest} createEntityInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost: async (entityId: string, createEntityInstructionVersionRequest: CreateEntityInstructionVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost', 'entityId', entityId)
            // verify required parameter 'createEntityInstructionVersionRequest' is not null or undefined
            assertParamExists('updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost', 'createEntityInstructionVersionRequest', createEntityInstructionVersionRequest)
            const localVarPath = `/api/v1/entities/{entity_id}/instructions/update`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEntityInstructionVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntitiesApi - functional programming interface
 */
export const EntitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an entity by resolving (or creating) the corresponding CDS party. For `ledger_recon`, `counter_party_type` is required; for `pg_recon` and `bank_recon` it must be omitted.
         * @summary Create Entity (CDS find-or-create)
         * @param {CreateEntityRequest} createEntityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityApiV1EntitiesPost(createEntityRequest: CreateEntityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityApiV1EntitiesPost(createEntityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.createEntityApiV1EntitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete an entity by setting is_deleted=True
         * @summary Soft Delete Entity
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityApiV1EntitiesEntityIdDeletePost(entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityApiV1EntitiesEntityIdDeletePost(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.deleteEntityApiV1EntitiesEntityIdDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete a specific entity instruction version (sets is_deleted=True). The currently active version cannot be deleted.
         * @summary Delete an Entity Instruction Version
         * @param {string} entityId 
         * @param {DeleteInstructionVersionRequest} deleteInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost(entityId: string, deleteInstructionVersionRequest: DeleteInstructionVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstruction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost(entityId, deleteInstructionVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get entities with pagination, filtering, and search. Each row is enriched with its resolved CDS party identity.
         * @summary Get Entities
         * @param {JobType} type Reconciliation type
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Number of entities per page
         * @param {string | null} [id] Entity ID
         * @param {string | null} [search] Search term forwarded to CDS (CDS-first)
         * @param {AppModelsDomainModelsJobsPerspective | null} [counterPartyType] Filter by counter-party type (ledger_recon only).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitiesApiV1EntitiesGet(type: JobType, page?: number, limit?: number, id?: string | null, search?: string | null, counterPartyType?: AppModelsDomainModelsJobsPerspective | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEntitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitiesApiV1EntitiesGet(type, page, limit, id, search, counterPartyType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.getEntitiesApiV1EntitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a single entity by ID, enriched with the resolved CDS party identity.
         * @summary Get Entity by ID
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityApiV1EntitiesEntityIdGet(entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityApiV1EntitiesEntityIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.getEntityApiV1EntitiesEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the active (or specific) instruction version for an entity addressed by ID.
         * @summary Get Entity Instructions by ID
         * @param {string} entityId 
         * @param {number | null} [versionNumber] Instruction version number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet(entityId: string, versionNumber?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityInstructions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet(entityId, versionNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Activate a specific entity instruction version. The previously active version is automatically deactivated.
         * @summary Mark Entity Instruction Version as Active
         * @param {string} entityId 
         * @param {MarkVersionActiveRequest} markVersionActiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost(entityId: string, markVersionActiveRequest: MarkVersionActiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstruction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost(entityId, markVersionActiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new entity instruction version. Version numbers are assigned automatically.
         * @summary Update Entity Instructions
         * @param {string} entityId 
         * @param {CreateEntityInstructionVersionRequest} createEntityInstructionVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost(entityId: string, createEntityInstructionVersionRequest: CreateEntityInstructionVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInstruction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost(entityId, createEntityInstructionVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitiesApi.updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntitiesApi - factory interface
 */
export const EntitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntitiesApiFp(configuration)
    return {
        /**
         * Create an entity by resolving (or creating) the corresponding CDS party. For `ledger_recon`, `counter_party_type` is required; for `pg_recon` and `bank_recon` it must be omitted.
         * @summary Create Entity (CDS find-or-create)
         * @param {EntitiesApiCreateEntityApiV1EntitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityApiV1EntitiesPost(requestParameters: EntitiesApiCreateEntityApiV1EntitiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Entity> {
            return localVarFp.createEntityApiV1EntitiesPost(requestParameters.createEntityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete an entity by setting is_deleted=True
         * @summary Soft Delete Entity
         * @param {EntitiesApiDeleteEntityApiV1EntitiesEntityIdDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityApiV1EntitiesEntityIdDeletePost(requestParameters: EntitiesApiDeleteEntityApiV1EntitiesEntityIdDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Entity> {
            return localVarFp.deleteEntityApiV1EntitiesEntityIdDeletePost(requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a specific entity instruction version (sets is_deleted=True). The currently active version cannot be deleted.
         * @summary Delete an Entity Instruction Version
         * @param {EntitiesApiDeleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost(requestParameters: EntitiesApiDeleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstruction> {
            return localVarFp.deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost(requestParameters.entityId, requestParameters.deleteInstructionVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get entities with pagination, filtering, and search. Each row is enriched with its resolved CDS party identity.
         * @summary Get Entities
         * @param {EntitiesApiGetEntitiesApiV1EntitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitiesApiV1EntitiesGet(requestParameters: EntitiesApiGetEntitiesApiV1EntitiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEntitiesResponse> {
            return localVarFp.getEntitiesApiV1EntitiesGet(requestParameters.type, requestParameters.page, requestParameters.limit, requestParameters.id, requestParameters.search, requestParameters.counterPartyType, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a single entity by ID, enriched with the resolved CDS party identity.
         * @summary Get Entity by ID
         * @param {EntitiesApiGetEntityApiV1EntitiesEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityApiV1EntitiesEntityIdGet(requestParameters: EntitiesApiGetEntityApiV1EntitiesEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Entity> {
            return localVarFp.getEntityApiV1EntitiesEntityIdGet(requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the active (or specific) instruction version for an entity addressed by ID.
         * @summary Get Entity Instructions by ID
         * @param {EntitiesApiGetEntityInstructionsApiV1EntitiesEntityIdInstructionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet(requestParameters: EntitiesApiGetEntityInstructionsApiV1EntitiesEntityIdInstructionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityInstructions> {
            return localVarFp.getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet(requestParameters.entityId, requestParameters.versionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Activate a specific entity instruction version. The previously active version is automatically deactivated.
         * @summary Mark Entity Instruction Version as Active
         * @param {EntitiesApiMarkEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost(requestParameters: EntitiesApiMarkEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstruction> {
            return localVarFp.markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost(requestParameters.entityId, requestParameters.markVersionActiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new entity instruction version. Version numbers are assigned automatically.
         * @summary Update Entity Instructions
         * @param {EntitiesApiUpdateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost(requestParameters: EntitiesApiUpdateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerInstruction> {
            return localVarFp.updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost(requestParameters.entityId, requestParameters.createEntityInstructionVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createEntityApiV1EntitiesPost operation in EntitiesApi.
 */
export interface EntitiesApiCreateEntityApiV1EntitiesPostRequest {
    readonly createEntityRequest: CreateEntityRequest
}

/**
 * Request parameters for deleteEntityApiV1EntitiesEntityIdDeletePost operation in EntitiesApi.
 */
export interface EntitiesApiDeleteEntityApiV1EntitiesEntityIdDeletePostRequest {
    readonly entityId: string
}

/**
 * Request parameters for deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost operation in EntitiesApi.
 */
export interface EntitiesApiDeleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePostRequest {
    readonly entityId: string

    readonly deleteInstructionVersionRequest: DeleteInstructionVersionRequest
}

/**
 * Request parameters for getEntitiesApiV1EntitiesGet operation in EntitiesApi.
 */
export interface EntitiesApiGetEntitiesApiV1EntitiesGetRequest {
    /**
     * Reconciliation type
     */
    readonly type: JobType

    /**
     * Page number (1-based)
     */
    readonly page?: number

    /**
     * Number of entities per page
     */
    readonly limit?: number

    /**
     * Entity ID
     */
    readonly id?: string | null

    /**
     * Search term forwarded to CDS (CDS-first)
     */
    readonly search?: string | null

    /**
     * Filter by counter-party type (ledger_recon only).
     */
    readonly counterPartyType?: AppModelsDomainModelsJobsPerspective | null
}

/**
 * Request parameters for getEntityApiV1EntitiesEntityIdGet operation in EntitiesApi.
 */
export interface EntitiesApiGetEntityApiV1EntitiesEntityIdGetRequest {
    readonly entityId: string
}

/**
 * Request parameters for getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet operation in EntitiesApi.
 */
export interface EntitiesApiGetEntityInstructionsApiV1EntitiesEntityIdInstructionsGetRequest {
    readonly entityId: string

    /**
     * Instruction version number
     */
    readonly versionNumber?: number | null
}

/**
 * Request parameters for markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost operation in EntitiesApi.
 */
export interface EntitiesApiMarkEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePostRequest {
    readonly entityId: string

    readonly markVersionActiveRequest: MarkVersionActiveRequest
}

/**
 * Request parameters for updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost operation in EntitiesApi.
 */
export interface EntitiesApiUpdateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePostRequest {
    readonly entityId: string

    readonly createEntityInstructionVersionRequest: CreateEntityInstructionVersionRequest
}

/**
 * EntitiesApi - object-oriented interface
 */
export class EntitiesApi extends BaseAPI {
    /**
     * Create an entity by resolving (or creating) the corresponding CDS party. For `ledger_recon`, `counter_party_type` is required; for `pg_recon` and `bank_recon` it must be omitted.
     * @summary Create Entity (CDS find-or-create)
     * @param {EntitiesApiCreateEntityApiV1EntitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEntityApiV1EntitiesPost(requestParameters: EntitiesApiCreateEntityApiV1EntitiesPostRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).createEntityApiV1EntitiesPost(requestParameters.createEntityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete an entity by setting is_deleted=True
     * @summary Soft Delete Entity
     * @param {EntitiesApiDeleteEntityApiV1EntitiesEntityIdDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEntityApiV1EntitiesEntityIdDeletePost(requestParameters: EntitiesApiDeleteEntityApiV1EntitiesEntityIdDeletePostRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).deleteEntityApiV1EntitiesEntityIdDeletePost(requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a specific entity instruction version (sets is_deleted=True). The currently active version cannot be deleted.
     * @summary Delete an Entity Instruction Version
     * @param {EntitiesApiDeleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost(requestParameters: EntitiesApiDeleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePostRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).deleteEntityInstructionVersionApiV1EntitiesEntityIdInstructionsDeletePost(requestParameters.entityId, requestParameters.deleteInstructionVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get entities with pagination, filtering, and search. Each row is enriched with its resolved CDS party identity.
     * @summary Get Entities
     * @param {EntitiesApiGetEntitiesApiV1EntitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEntitiesApiV1EntitiesGet(requestParameters: EntitiesApiGetEntitiesApiV1EntitiesGetRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).getEntitiesApiV1EntitiesGet(requestParameters.type, requestParameters.page, requestParameters.limit, requestParameters.id, requestParameters.search, requestParameters.counterPartyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a single entity by ID, enriched with the resolved CDS party identity.
     * @summary Get Entity by ID
     * @param {EntitiesApiGetEntityApiV1EntitiesEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEntityApiV1EntitiesEntityIdGet(requestParameters: EntitiesApiGetEntityApiV1EntitiesEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).getEntityApiV1EntitiesEntityIdGet(requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the active (or specific) instruction version for an entity addressed by ID.
     * @summary Get Entity Instructions by ID
     * @param {EntitiesApiGetEntityInstructionsApiV1EntitiesEntityIdInstructionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet(requestParameters: EntitiesApiGetEntityInstructionsApiV1EntitiesEntityIdInstructionsGetRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).getEntityInstructionsApiV1EntitiesEntityIdInstructionsGet(requestParameters.entityId, requestParameters.versionNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activate a specific entity instruction version. The previously active version is automatically deactivated.
     * @summary Mark Entity Instruction Version as Active
     * @param {EntitiesApiMarkEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost(requestParameters: EntitiesApiMarkEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePostRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).markEntityInstructionVersionActiveApiV1EntitiesEntityIdInstructionsActivatePost(requestParameters.entityId, requestParameters.markVersionActiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new entity instruction version. Version numbers are assigned automatically.
     * @summary Update Entity Instructions
     * @param {EntitiesApiUpdateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost(requestParameters: EntitiesApiUpdateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return EntitiesApiFp(this.configuration).updateEntityInstructionsApiV1EntitiesEntityIdInstructionsUpdatePost(requestParameters.entityId, requestParameters.createEntityInstructionVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request cancellation of a reconciliation job by invoking the Bedrock AgentCore agent with action=\'cancel\'
         * @summary Cancel Job
         * @param {string} jobId 
         * @param {CancelJobRequest} cancelJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJobApiV1JobsJobIdCancelPost: async (jobId: string, cancelJobRequest: CancelJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('cancelJobApiV1JobsJobIdCancelPost', 'jobId', jobId)
            // verify required parameter 'cancelJobRequest' is not null or undefined
            assertParamExists('cancelJobApiV1JobsJobIdCancelPost', 'cancelJobRequest', cancelJobRequest)
            const localVarPath = `/api/v1/jobs/{job_id}/cancel`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a bank_recon job. Input files must have keys \'bank\' and \'ledger\'. Start_date, end_date, entity_name are required.
         * @summary Create Bank Reconciliation Job
         * @param {BankReconCreateJobRequest} bankReconCreateJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankReconJobApiV1JobsBankReconPost: async (bankReconCreateJobRequest: BankReconCreateJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankReconCreateJobRequest' is not null or undefined
            assertParamExists('createBankReconJobApiV1JobsBankReconPost', 'bankReconCreateJobRequest', bankReconCreateJobRequest)
            const localVarPath = `/api/v1/jobs/bank-recon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankReconCreateJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new reconciliation job with input files and return presigned URL for file upload
         * @summary Start Reconciliation Job
         * @param {CreateJobRequest} createJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobApiV1JobsPost: async (createJobRequest: CreateJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJobRequest' is not null or undefined
            assertParamExists('createJobApiV1JobsPost', 'createJobRequest', createJobRequest)
            const localVarPath = `/api/v1/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a ledger_recon job. Input files must have keys \'our\' and \'their\'. Perspective, start_date, end_date, entity_name are required; balances is optional. Optional: workflow_reference (reference with id/workflow, and optionally bucket/external_files to copy from external S3); when bucket and external_files are set, files are copied into the service bucket and presigned URLs are not returned.
         * @summary Create Ledger Reconciliation Job
         * @param {LedgerReconCreateJobRequest} ledgerReconCreateJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerReconJobApiV1JobsLedgerReconPost: async (ledgerReconCreateJobRequest: LedgerReconCreateJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ledgerReconCreateJobRequest' is not null or undefined
            assertParamExists('createLedgerReconJobApiV1JobsLedgerReconPost', 'ledgerReconCreateJobRequest', ledgerReconCreateJobRequest)
            const localVarPath = `/api/v1/jobs/ledger-recon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ledgerReconCreateJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a pg_recon job. Input files must have keys \'pg_report\' and \'ledger\'. Start_date, end_date, entity_name are required.
         * @summary Create PG Reconciliation Job
         * @param {PgReconCreateJobRequest} pgReconCreateJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPgReconJobApiV1JobsPgReconPost: async (pgReconCreateJobRequest: PgReconCreateJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pgReconCreateJobRequest' is not null or undefined
            assertParamExists('createPgReconJobApiV1JobsPgReconPost', 'pgReconCreateJobRequest', pgReconCreateJobRequest)
            const localVarPath = `/api/v1/jobs/pg-recon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pgReconCreateJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate Excel report and return a presigned download URL for the report file
         * @summary Generate Excel Report
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExcelReportApiV1JobsJobIdReportGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('generateExcelReportApiV1JobsJobIdReportGet', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{job_id}/report`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get jobs for a specific customer with pagination
         * @summary Get Customer Jobs
         * @param {JobType} type Type of job
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Number of jobs per page
         * @param {string} [entityName] Entity name from job metadata
         * @param {string} [entityId] CDS party UUID to filter jobs for a specific entity
         * @param {string} [search] Search term to filter by job ID or entity name (case-insensitive partial match)
         * @param {string} [workflowReferenceId] Filter by workflow_reference.id from job metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerJobsApiV1JobsGet: async (type: JobType, page?: number, limit?: number, entityName?: string, entityId?: string, search?: string, workflowReferenceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getCustomerJobsApiV1JobsGet', 'type', type)
            const localVarPath = `/api/v1/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (entityName !== undefined) {
                localVarQueryParameter['entity_name'] = entityName;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (workflowReferenceId !== undefined) {
                localVarQueryParameter['workflow_reference_id'] = workflowReferenceId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a reconciliation job by ID
         * @summary Get Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobByIdApiV1JobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobByIdApiV1JobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the reconciliation summary for a completed job
         * @summary Get Reconciliation Summary
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobSummaryApiV1JobsJobIdSummaryGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobSummaryApiV1JobsJobIdSummaryGet', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{job_id}/summary`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return customer-level completed-job count (used) for a recon type. Quota limits come from CDS customer config, not this endpoint.
         * @summary Get Job Quota Usage
         * @param {JobType} type Reconciliation type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotaUsageApiV1JobsQuotaGet: async (type: JobType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getQuotaUsageApiV1JobsQuotaGet', 'type', type)
            const localVarPath = `/api/v1/jobs/quota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new job with the same workspace_id as the original job, with optional updated instructions
         * @summary Retry Job
         * @param {string} jobId 
         * @param {RetryJobRequest} retryJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryJobApiV1JobsJobIdRetryPost: async (jobId: string, retryJobRequest: RetryJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('retryJobApiV1JobsJobIdRetryPost', 'jobId', jobId)
            // verify required parameter 'retryJobRequest' is not null or undefined
            assertParamExists('retryJobApiV1JobsJobIdRetryPost', 'retryJobRequest', retryJobRequest)
            const localVarPath = `/api/v1/jobs/{job_id}/retry`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a job as deleted by setting the deleted flag to true. Optional deleted_by is logged in job metadata.
         * @summary Soft Delete Job
         * @param {string} jobId 
         * @param {DeleteJobRequest} deleteJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteJobApiV1JobsJobIdDeletePost: async (jobId: string, deleteJobRequest: DeleteJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('softDeleteJobApiV1JobsJobIdDeletePost', 'jobId', jobId)
            // verify required parameter 'deleteJobRequest' is not null or undefined
            assertParamExists('softDeleteJobApiV1JobsJobIdDeletePost', 'deleteJobRequest', deleteJobRequest)
            const localVarPath = `/api/v1/jobs/{job_id}/delete`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start processing a reconciliation job by creating and executing AI tasks
         * @summary Start Job Processing
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startJobProcessingApiV1JobsJobIdStartProcessingPost: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('startJobProcessingApiV1JobsJobIdStartProcessingPost', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{job_id}/start-processing`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the reconciliation summary for a job with metrics
         * @summary Update Recon Summary
         * @param {string} jobId 
         * @param {UpdateReconSummaryRequest} updateReconSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReconSummaryApiV1JobsJobIdUpdateSummaryPost: async (jobId: string, updateReconSummaryRequest: UpdateReconSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('updateReconSummaryApiV1JobsJobIdUpdateSummaryPost', 'jobId', jobId)
            // verify required parameter 'updateReconSummaryRequest' is not null or undefined
            assertParamExists('updateReconSummaryApiV1JobsJobIdUpdateSummaryPost', 'updateReconSummaryRequest', updateReconSummaryRequest)
            const localVarPath = `/api/v1/jobs/{job_id}/update-summary`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReconSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Request cancellation of a reconciliation job by invoking the Bedrock AgentCore agent with action=\'cancel\'
         * @summary Cancel Job
         * @param {string} jobId 
         * @param {CancelJobRequest} cancelJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelJobApiV1JobsJobIdCancelPost(jobId: string, cancelJobRequest: CancelJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelJobApiV1JobsJobIdCancelPost(jobId, cancelJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.cancelJobApiV1JobsJobIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a bank_recon job. Input files must have keys \'bank\' and \'ledger\'. Start_date, end_date, entity_name are required.
         * @summary Create Bank Reconciliation Job
         * @param {BankReconCreateJobRequest} bankReconCreateJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankReconJobApiV1JobsBankReconPost(bankReconCreateJobRequest: BankReconCreateJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankReconJobApiV1JobsBankReconPost(bankReconCreateJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createBankReconJobApiV1JobsBankReconPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new reconciliation job with input files and return presigned URL for file upload
         * @summary Start Reconciliation Job
         * @param {CreateJobRequest} createJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobApiV1JobsPost(createJobRequest: CreateJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobApiV1JobsPost(createJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createJobApiV1JobsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a ledger_recon job. Input files must have keys \'our\' and \'their\'. Perspective, start_date, end_date, entity_name are required; balances is optional. Optional: workflow_reference (reference with id/workflow, and optionally bucket/external_files to copy from external S3); when bucket and external_files are set, files are copied into the service bucket and presigned URLs are not returned.
         * @summary Create Ledger Reconciliation Job
         * @param {LedgerReconCreateJobRequest} ledgerReconCreateJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLedgerReconJobApiV1JobsLedgerReconPost(ledgerReconCreateJobRequest: LedgerReconCreateJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLedgerReconJobApiV1JobsLedgerReconPost(ledgerReconCreateJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createLedgerReconJobApiV1JobsLedgerReconPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a pg_recon job. Input files must have keys \'pg_report\' and \'ledger\'. Start_date, end_date, entity_name are required.
         * @summary Create PG Reconciliation Job
         * @param {PgReconCreateJobRequest} pgReconCreateJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPgReconJobApiV1JobsPgReconPost(pgReconCreateJobRequest: PgReconCreateJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPgReconJobApiV1JobsPgReconPost(pgReconCreateJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.createPgReconJobApiV1JobsPgReconPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate Excel report and return a presigned download URL for the report file
         * @summary Generate Excel Report
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateExcelReportApiV1JobsJobIdReportGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcelReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateExcelReportApiV1JobsJobIdReportGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.generateExcelReportApiV1JobsJobIdReportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get jobs for a specific customer with pagination
         * @summary Get Customer Jobs
         * @param {JobType} type Type of job
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Number of jobs per page
         * @param {string} [entityName] Entity name from job metadata
         * @param {string} [entityId] CDS party UUID to filter jobs for a specific entity
         * @param {string} [search] Search term to filter by job ID or entity name (case-insensitive partial match)
         * @param {string} [workflowReferenceId] Filter by workflow_reference.id from job metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerJobsApiV1JobsGet(type: JobType, page?: number, limit?: number, entityName?: string, entityId?: string, search?: string, workflowReferenceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerJobsApiV1JobsGet(type, page, limit, entityName, entityId, search, workflowReferenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getCustomerJobsApiV1JobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a reconciliation job by ID
         * @summary Get Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobByIdApiV1JobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobByIdApiV1JobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobByIdApiV1JobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the reconciliation summary for a completed job
         * @summary Get Reconciliation Summary
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobSummaryApiV1JobsJobIdSummaryGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobSummaryApiV1JobsJobIdSummaryGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobSummaryApiV1JobsJobIdSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return customer-level completed-job count (used) for a recon type. Quota limits come from CDS customer config, not this endpoint.
         * @summary Get Job Quota Usage
         * @param {JobType} type Reconciliation type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuotaUsageApiV1JobsQuotaGet(type: JobType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobQuotaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuotaUsageApiV1JobsQuotaGet(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getQuotaUsageApiV1JobsQuotaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new job with the same workspace_id as the original job, with optional updated instructions
         * @summary Retry Job
         * @param {string} jobId 
         * @param {RetryJobRequest} retryJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryJobApiV1JobsJobIdRetryPost(jobId: string, retryJobRequest: RetryJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryJobApiV1JobsJobIdRetryPost(jobId, retryJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.retryJobApiV1JobsJobIdRetryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a job as deleted by setting the deleted flag to true. Optional deleted_by is logged in job metadata.
         * @summary Soft Delete Job
         * @param {string} jobId 
         * @param {DeleteJobRequest} deleteJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteJobApiV1JobsJobIdDeletePost(jobId: string, deleteJobRequest: DeleteJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteJobApiV1JobsJobIdDeletePost(jobId, deleteJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.softDeleteJobApiV1JobsJobIdDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start processing a reconciliation job by creating and executing AI tasks
         * @summary Start Job Processing
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startJobProcessingApiV1JobsJobIdStartProcessingPost(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startJobProcessingApiV1JobsJobIdStartProcessingPost(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.startJobProcessingApiV1JobsJobIdStartProcessingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the reconciliation summary for a job with metrics
         * @summary Update Recon Summary
         * @param {string} jobId 
         * @param {UpdateReconSummaryRequest} updateReconSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReconSummaryApiV1JobsJobIdUpdateSummaryPost(jobId: string, updateReconSummaryRequest: UpdateReconSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReconSummaryApiV1JobsJobIdUpdateSummaryPost(jobId, updateReconSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.updateReconSummaryApiV1JobsJobIdUpdateSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * Request cancellation of a reconciliation job by invoking the Bedrock AgentCore agent with action=\'cancel\'
         * @summary Cancel Job
         * @param {JobsApiCancelJobApiV1JobsJobIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelJobApiV1JobsJobIdCancelPost(requestParameters: JobsApiCancelJobApiV1JobsJobIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.cancelJobApiV1JobsJobIdCancelPost(requestParameters.jobId, requestParameters.cancelJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a bank_recon job. Input files must have keys \'bank\' and \'ledger\'. Start_date, end_date, entity_name are required.
         * @summary Create Bank Reconciliation Job
         * @param {JobsApiCreateBankReconJobApiV1JobsBankReconPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankReconJobApiV1JobsBankReconPost(requestParameters: JobsApiCreateBankReconJobApiV1JobsBankReconPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobResponse> {
            return localVarFp.createBankReconJobApiV1JobsBankReconPost(requestParameters.bankReconCreateJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new reconciliation job with input files and return presigned URL for file upload
         * @summary Start Reconciliation Job
         * @param {JobsApiCreateJobApiV1JobsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobApiV1JobsPost(requestParameters: JobsApiCreateJobApiV1JobsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobResponse> {
            return localVarFp.createJobApiV1JobsPost(requestParameters.createJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a ledger_recon job. Input files must have keys \'our\' and \'their\'. Perspective, start_date, end_date, entity_name are required; balances is optional. Optional: workflow_reference (reference with id/workflow, and optionally bucket/external_files to copy from external S3); when bucket and external_files are set, files are copied into the service bucket and presigned URLs are not returned.
         * @summary Create Ledger Reconciliation Job
         * @param {JobsApiCreateLedgerReconJobApiV1JobsLedgerReconPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerReconJobApiV1JobsLedgerReconPost(requestParameters: JobsApiCreateLedgerReconJobApiV1JobsLedgerReconPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobResponse> {
            return localVarFp.createLedgerReconJobApiV1JobsLedgerReconPost(requestParameters.ledgerReconCreateJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a pg_recon job. Input files must have keys \'pg_report\' and \'ledger\'. Start_date, end_date, entity_name are required.
         * @summary Create PG Reconciliation Job
         * @param {JobsApiCreatePgReconJobApiV1JobsPgReconPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPgReconJobApiV1JobsPgReconPost(requestParameters: JobsApiCreatePgReconJobApiV1JobsPgReconPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobResponse> {
            return localVarFp.createPgReconJobApiV1JobsPgReconPost(requestParameters.pgReconCreateJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate Excel report and return a presigned download URL for the report file
         * @summary Generate Excel Report
         * @param {JobsApiGenerateExcelReportApiV1JobsJobIdReportGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExcelReportApiV1JobsJobIdReportGet(requestParameters: JobsApiGenerateExcelReportApiV1JobsJobIdReportGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExcelReportResponse> {
            return localVarFp.generateExcelReportApiV1JobsJobIdReportGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get jobs for a specific customer with pagination
         * @summary Get Customer Jobs
         * @param {JobsApiGetCustomerJobsApiV1JobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerJobsApiV1JobsGet(requestParameters: JobsApiGetCustomerJobsApiV1JobsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedJobsResponse> {
            return localVarFp.getCustomerJobsApiV1JobsGet(requestParameters.type, requestParameters.page, requestParameters.limit, requestParameters.entityName, requestParameters.entityId, requestParameters.search, requestParameters.workflowReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a reconciliation job by ID
         * @summary Get Job
         * @param {JobsApiGetJobByIdApiV1JobsJobIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobByIdApiV1JobsJobIdGet(requestParameters: JobsApiGetJobByIdApiV1JobsJobIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.getJobByIdApiV1JobsJobIdGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the reconciliation summary for a completed job
         * @summary Get Reconciliation Summary
         * @param {JobsApiGetJobSummaryApiV1JobsJobIdSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobSummaryApiV1JobsJobIdSummaryGet(requestParameters: JobsApiGetJobSummaryApiV1JobsJobIdSummaryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSummaryResponse> {
            return localVarFp.getJobSummaryApiV1JobsJobIdSummaryGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return customer-level completed-job count (used) for a recon type. Quota limits come from CDS customer config, not this endpoint.
         * @summary Get Job Quota Usage
         * @param {JobsApiGetQuotaUsageApiV1JobsQuotaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotaUsageApiV1JobsQuotaGet(requestParameters: JobsApiGetQuotaUsageApiV1JobsQuotaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobQuotaResponse> {
            return localVarFp.getQuotaUsageApiV1JobsQuotaGet(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new job with the same workspace_id as the original job, with optional updated instructions
         * @summary Retry Job
         * @param {JobsApiRetryJobApiV1JobsJobIdRetryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryJobApiV1JobsJobIdRetryPost(requestParameters: JobsApiRetryJobApiV1JobsJobIdRetryPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.retryJobApiV1JobsJobIdRetryPost(requestParameters.jobId, requestParameters.retryJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a job as deleted by setting the deleted flag to true. Optional deleted_by is logged in job metadata.
         * @summary Soft Delete Job
         * @param {JobsApiSoftDeleteJobApiV1JobsJobIdDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteJobApiV1JobsJobIdDeletePost(requestParameters: JobsApiSoftDeleteJobApiV1JobsJobIdDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.softDeleteJobApiV1JobsJobIdDeletePost(requestParameters.jobId, requestParameters.deleteJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start processing a reconciliation job by creating and executing AI tasks
         * @summary Start Job Processing
         * @param {JobsApiStartJobProcessingApiV1JobsJobIdStartProcessingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startJobProcessingApiV1JobsJobIdStartProcessingPost(requestParameters: JobsApiStartJobProcessingApiV1JobsJobIdStartProcessingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Job> {
            return localVarFp.startJobProcessingApiV1JobsJobIdStartProcessingPost(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the reconciliation summary for a job with metrics
         * @summary Update Recon Summary
         * @param {JobsApiUpdateReconSummaryApiV1JobsJobIdUpdateSummaryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReconSummaryApiV1JobsJobIdUpdateSummaryPost(requestParameters: JobsApiUpdateReconSummaryApiV1JobsJobIdUpdateSummaryPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobSummaryResponse> {
            return localVarFp.updateReconSummaryApiV1JobsJobIdUpdateSummaryPost(requestParameters.jobId, requestParameters.updateReconSummaryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelJobApiV1JobsJobIdCancelPost operation in JobsApi.
 */
export interface JobsApiCancelJobApiV1JobsJobIdCancelPostRequest {
    readonly jobId: string

    readonly cancelJobRequest: CancelJobRequest
}

/**
 * Request parameters for createBankReconJobApiV1JobsBankReconPost operation in JobsApi.
 */
export interface JobsApiCreateBankReconJobApiV1JobsBankReconPostRequest {
    readonly bankReconCreateJobRequest: BankReconCreateJobRequest
}

/**
 * Request parameters for createJobApiV1JobsPost operation in JobsApi.
 */
export interface JobsApiCreateJobApiV1JobsPostRequest {
    readonly createJobRequest: CreateJobRequest
}

/**
 * Request parameters for createLedgerReconJobApiV1JobsLedgerReconPost operation in JobsApi.
 */
export interface JobsApiCreateLedgerReconJobApiV1JobsLedgerReconPostRequest {
    readonly ledgerReconCreateJobRequest: LedgerReconCreateJobRequest
}

/**
 * Request parameters for createPgReconJobApiV1JobsPgReconPost operation in JobsApi.
 */
export interface JobsApiCreatePgReconJobApiV1JobsPgReconPostRequest {
    readonly pgReconCreateJobRequest: PgReconCreateJobRequest
}

/**
 * Request parameters for generateExcelReportApiV1JobsJobIdReportGet operation in JobsApi.
 */
export interface JobsApiGenerateExcelReportApiV1JobsJobIdReportGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for getCustomerJobsApiV1JobsGet operation in JobsApi.
 */
export interface JobsApiGetCustomerJobsApiV1JobsGetRequest {
    /**
     * Type of job
     */
    readonly type: JobType

    /**
     * Page number (1-based)
     */
    readonly page?: number

    /**
     * Number of jobs per page
     */
    readonly limit?: number

    /**
     * Entity name from job metadata
     */
    readonly entityName?: string

    /**
     * CDS party UUID to filter jobs for a specific entity
     */
    readonly entityId?: string

    /**
     * Search term to filter by job ID or entity name (case-insensitive partial match)
     */
    readonly search?: string

    /**
     * Filter by workflow_reference.id from job metadata
     */
    readonly workflowReferenceId?: string
}

/**
 * Request parameters for getJobByIdApiV1JobsJobIdGet operation in JobsApi.
 */
export interface JobsApiGetJobByIdApiV1JobsJobIdGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for getJobSummaryApiV1JobsJobIdSummaryGet operation in JobsApi.
 */
export interface JobsApiGetJobSummaryApiV1JobsJobIdSummaryGetRequest {
    readonly jobId: string
}

/**
 * Request parameters for getQuotaUsageApiV1JobsQuotaGet operation in JobsApi.
 */
export interface JobsApiGetQuotaUsageApiV1JobsQuotaGetRequest {
    /**
     * Reconciliation type
     */
    readonly type: JobType
}

/**
 * Request parameters for retryJobApiV1JobsJobIdRetryPost operation in JobsApi.
 */
export interface JobsApiRetryJobApiV1JobsJobIdRetryPostRequest {
    readonly jobId: string

    readonly retryJobRequest: RetryJobRequest
}

/**
 * Request parameters for softDeleteJobApiV1JobsJobIdDeletePost operation in JobsApi.
 */
export interface JobsApiSoftDeleteJobApiV1JobsJobIdDeletePostRequest {
    readonly jobId: string

    readonly deleteJobRequest: DeleteJobRequest
}

/**
 * Request parameters for startJobProcessingApiV1JobsJobIdStartProcessingPost operation in JobsApi.
 */
export interface JobsApiStartJobProcessingApiV1JobsJobIdStartProcessingPostRequest {
    readonly jobId: string
}

/**
 * Request parameters for updateReconSummaryApiV1JobsJobIdUpdateSummaryPost operation in JobsApi.
 */
export interface JobsApiUpdateReconSummaryApiV1JobsJobIdUpdateSummaryPostRequest {
    readonly jobId: string

    readonly updateReconSummaryRequest: UpdateReconSummaryRequest
}

/**
 * JobsApi - object-oriented interface
 */
export class JobsApi extends BaseAPI {
    /**
     * Request cancellation of a reconciliation job by invoking the Bedrock AgentCore agent with action=\'cancel\'
     * @summary Cancel Job
     * @param {JobsApiCancelJobApiV1JobsJobIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelJobApiV1JobsJobIdCancelPost(requestParameters: JobsApiCancelJobApiV1JobsJobIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).cancelJobApiV1JobsJobIdCancelPost(requestParameters.jobId, requestParameters.cancelJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a bank_recon job. Input files must have keys \'bank\' and \'ledger\'. Start_date, end_date, entity_name are required.
     * @summary Create Bank Reconciliation Job
     * @param {JobsApiCreateBankReconJobApiV1JobsBankReconPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBankReconJobApiV1JobsBankReconPost(requestParameters: JobsApiCreateBankReconJobApiV1JobsBankReconPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createBankReconJobApiV1JobsBankReconPost(requestParameters.bankReconCreateJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new reconciliation job with input files and return presigned URL for file upload
     * @summary Start Reconciliation Job
     * @param {JobsApiCreateJobApiV1JobsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJobApiV1JobsPost(requestParameters: JobsApiCreateJobApiV1JobsPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createJobApiV1JobsPost(requestParameters.createJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a ledger_recon job. Input files must have keys \'our\' and \'their\'. Perspective, start_date, end_date, entity_name are required; balances is optional. Optional: workflow_reference (reference with id/workflow, and optionally bucket/external_files to copy from external S3); when bucket and external_files are set, files are copied into the service bucket and presigned URLs are not returned.
     * @summary Create Ledger Reconciliation Job
     * @param {JobsApiCreateLedgerReconJobApiV1JobsLedgerReconPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLedgerReconJobApiV1JobsLedgerReconPost(requestParameters: JobsApiCreateLedgerReconJobApiV1JobsLedgerReconPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createLedgerReconJobApiV1JobsLedgerReconPost(requestParameters.ledgerReconCreateJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a pg_recon job. Input files must have keys \'pg_report\' and \'ledger\'. Start_date, end_date, entity_name are required.
     * @summary Create PG Reconciliation Job
     * @param {JobsApiCreatePgReconJobApiV1JobsPgReconPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPgReconJobApiV1JobsPgReconPost(requestParameters: JobsApiCreatePgReconJobApiV1JobsPgReconPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).createPgReconJobApiV1JobsPgReconPost(requestParameters.pgReconCreateJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate Excel report and return a presigned download URL for the report file
     * @summary Generate Excel Report
     * @param {JobsApiGenerateExcelReportApiV1JobsJobIdReportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateExcelReportApiV1JobsJobIdReportGet(requestParameters: JobsApiGenerateExcelReportApiV1JobsJobIdReportGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).generateExcelReportApiV1JobsJobIdReportGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get jobs for a specific customer with pagination
     * @summary Get Customer Jobs
     * @param {JobsApiGetCustomerJobsApiV1JobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerJobsApiV1JobsGet(requestParameters: JobsApiGetCustomerJobsApiV1JobsGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getCustomerJobsApiV1JobsGet(requestParameters.type, requestParameters.page, requestParameters.limit, requestParameters.entityName, requestParameters.entityId, requestParameters.search, requestParameters.workflowReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a reconciliation job by ID
     * @summary Get Job
     * @param {JobsApiGetJobByIdApiV1JobsJobIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobByIdApiV1JobsJobIdGet(requestParameters: JobsApiGetJobByIdApiV1JobsJobIdGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobByIdApiV1JobsJobIdGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the reconciliation summary for a completed job
     * @summary Get Reconciliation Summary
     * @param {JobsApiGetJobSummaryApiV1JobsJobIdSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getJobSummaryApiV1JobsJobIdSummaryGet(requestParameters: JobsApiGetJobSummaryApiV1JobsJobIdSummaryGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobSummaryApiV1JobsJobIdSummaryGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return customer-level completed-job count (used) for a recon type. Quota limits come from CDS customer config, not this endpoint.
     * @summary Get Job Quota Usage
     * @param {JobsApiGetQuotaUsageApiV1JobsQuotaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getQuotaUsageApiV1JobsQuotaGet(requestParameters: JobsApiGetQuotaUsageApiV1JobsQuotaGetRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getQuotaUsageApiV1JobsQuotaGet(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new job with the same workspace_id as the original job, with optional updated instructions
     * @summary Retry Job
     * @param {JobsApiRetryJobApiV1JobsJobIdRetryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryJobApiV1JobsJobIdRetryPost(requestParameters: JobsApiRetryJobApiV1JobsJobIdRetryPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).retryJobApiV1JobsJobIdRetryPost(requestParameters.jobId, requestParameters.retryJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a job as deleted by setting the deleted flag to true. Optional deleted_by is logged in job metadata.
     * @summary Soft Delete Job
     * @param {JobsApiSoftDeleteJobApiV1JobsJobIdDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public softDeleteJobApiV1JobsJobIdDeletePost(requestParameters: JobsApiSoftDeleteJobApiV1JobsJobIdDeletePostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).softDeleteJobApiV1JobsJobIdDeletePost(requestParameters.jobId, requestParameters.deleteJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start processing a reconciliation job by creating and executing AI tasks
     * @summary Start Job Processing
     * @param {JobsApiStartJobProcessingApiV1JobsJobIdStartProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startJobProcessingApiV1JobsJobIdStartProcessingPost(requestParameters: JobsApiStartJobProcessingApiV1JobsJobIdStartProcessingPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).startJobProcessingApiV1JobsJobIdStartProcessingPost(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the reconciliation summary for a job with metrics
     * @summary Update Recon Summary
     * @param {JobsApiUpdateReconSummaryApiV1JobsJobIdUpdateSummaryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReconSummaryApiV1JobsJobIdUpdateSummaryPost(requestParameters: JobsApiUpdateReconSummaryApiV1JobsJobIdUpdateSummaryPostRequest, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).updateReconSummaryApiV1JobsJobIdUpdateSummaryPost(requestParameters.jobId, requestParameters.updateReconSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MemoryApi - axios parameter creator
 */
export const MemoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete one or more learning types for a given agent/customer/counterparty/perspective.
         * @summary Delete one or more learnings
         * @param {DeleteLearningRequest} deleteLearningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMemoryLearningApiV1MemoryLearningsDeletePost: async (deleteLearningRequest: DeleteLearningRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteLearningRequest' is not null or undefined
            assertParamExists('deleteMemoryLearningApiV1MemoryLearningsDeletePost', 'deleteLearningRequest', deleteLearningRequest)
            const localVarPath = `/api/v1/memory/learnings/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteLearningRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve one or more learning types for a given agent/customer/counterparty/perspective.
         * @summary Get memory learnings
         * @param {string} agentName 
         * @param {string} counterpartyName 
         * @param {string} perspective 
         * @param {JobType} reconType 
         * @param {Array<string>} learningTypes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryLearningsApiV1MemoryLearningsGet: async (agentName: string, counterpartyName: string, perspective: string, reconType: JobType, learningTypes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentName' is not null or undefined
            assertParamExists('getMemoryLearningsApiV1MemoryLearningsGet', 'agentName', agentName)
            // verify required parameter 'counterpartyName' is not null or undefined
            assertParamExists('getMemoryLearningsApiV1MemoryLearningsGet', 'counterpartyName', counterpartyName)
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getMemoryLearningsApiV1MemoryLearningsGet', 'perspective', perspective)
            // verify required parameter 'reconType' is not null or undefined
            assertParamExists('getMemoryLearningsApiV1MemoryLearningsGet', 'reconType', reconType)
            // verify required parameter 'learningTypes' is not null or undefined
            assertParamExists('getMemoryLearningsApiV1MemoryLearningsGet', 'learningTypes', learningTypes)
            const localVarPath = `/api/v1/memory/learnings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentName !== undefined) {
                localVarQueryParameter['agent_name'] = agentName;
            }

            if (counterpartyName !== undefined) {
                localVarQueryParameter['counterparty_name'] = counterpartyName;
            }

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (reconType !== undefined) {
                localVarQueryParameter['recon_type'] = reconType;
            }

            if (learningTypes) {
                localVarQueryParameter['learning_types'] = learningTypes;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a single learning type for a given agent/customer/counterparty/perspective.
         * @summary Store or update a learning
         * @param {StoreLearningRequest} storeLearningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMemoryLearningApiV1MemoryLearningsPost: async (storeLearningRequest: StoreLearningRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeLearningRequest' is not null or undefined
            assertParamExists('storeMemoryLearningApiV1MemoryLearningsPost', 'storeLearningRequest', storeLearningRequest)
            const localVarPath = `/api/v1/memory/learnings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storeLearningRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemoryApi - functional programming interface
 */
export const MemoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete one or more learning types for a given agent/customer/counterparty/perspective.
         * @summary Delete one or more learnings
         * @param {DeleteLearningRequest} deleteLearningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMemoryLearningApiV1MemoryLearningsDeletePost(deleteLearningRequest: DeleteLearningRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteLearningResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMemoryLearningApiV1MemoryLearningsDeletePost(deleteLearningRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.deleteMemoryLearningApiV1MemoryLearningsDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve one or more learning types for a given agent/customer/counterparty/perspective.
         * @summary Get memory learnings
         * @param {string} agentName 
         * @param {string} counterpartyName 
         * @param {string} perspective 
         * @param {JobType} reconType 
         * @param {Array<string>} learningTypes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemoryLearningsApiV1MemoryLearningsGet(agentName: string, counterpartyName: string, perspective: string, reconType: JobType, learningTypes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: GetLearningsResponseValue; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemoryLearningsApiV1MemoryLearningsGet(agentName, counterpartyName, perspective, reconType, learningTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.getMemoryLearningsApiV1MemoryLearningsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Store a single learning type for a given agent/customer/counterparty/perspective.
         * @summary Store or update a learning
         * @param {StoreLearningRequest} storeLearningRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeMemoryLearningApiV1MemoryLearningsPost(storeLearningRequest: StoreLearningRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreLearningResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeMemoryLearningApiV1MemoryLearningsPost(storeLearningRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.storeMemoryLearningApiV1MemoryLearningsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MemoryApi - factory interface
 */
export const MemoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemoryApiFp(configuration)
    return {
        /**
         * Delete one or more learning types for a given agent/customer/counterparty/perspective.
         * @summary Delete one or more learnings
         * @param {MemoryApiDeleteMemoryLearningApiV1MemoryLearningsDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMemoryLearningApiV1MemoryLearningsDeletePost(requestParameters: MemoryApiDeleteMemoryLearningApiV1MemoryLearningsDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteLearningResponse> {
            return localVarFp.deleteMemoryLearningApiV1MemoryLearningsDeletePost(requestParameters.deleteLearningRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve one or more learning types for a given agent/customer/counterparty/perspective.
         * @summary Get memory learnings
         * @param {MemoryApiGetMemoryLearningsApiV1MemoryLearningsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemoryLearningsApiV1MemoryLearningsGet(requestParameters: MemoryApiGetMemoryLearningsApiV1MemoryLearningsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: GetLearningsResponseValue; }> {
            return localVarFp.getMemoryLearningsApiV1MemoryLearningsGet(requestParameters.agentName, requestParameters.counterpartyName, requestParameters.perspective, requestParameters.reconType, requestParameters.learningTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a single learning type for a given agent/customer/counterparty/perspective.
         * @summary Store or update a learning
         * @param {MemoryApiStoreMemoryLearningApiV1MemoryLearningsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeMemoryLearningApiV1MemoryLearningsPost(requestParameters: MemoryApiStoreMemoryLearningApiV1MemoryLearningsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<StoreLearningResponse> {
            return localVarFp.storeMemoryLearningApiV1MemoryLearningsPost(requestParameters.storeLearningRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteMemoryLearningApiV1MemoryLearningsDeletePost operation in MemoryApi.
 */
export interface MemoryApiDeleteMemoryLearningApiV1MemoryLearningsDeletePostRequest {
    readonly deleteLearningRequest: DeleteLearningRequest
}

/**
 * Request parameters for getMemoryLearningsApiV1MemoryLearningsGet operation in MemoryApi.
 */
export interface MemoryApiGetMemoryLearningsApiV1MemoryLearningsGetRequest {
    readonly agentName: string

    readonly counterpartyName: string

    readonly perspective: string

    readonly reconType: JobType

    readonly learningTypes: Array<string>
}

/**
 * Request parameters for storeMemoryLearningApiV1MemoryLearningsPost operation in MemoryApi.
 */
export interface MemoryApiStoreMemoryLearningApiV1MemoryLearningsPostRequest {
    readonly storeLearningRequest: StoreLearningRequest
}

/**
 * MemoryApi - object-oriented interface
 */
export class MemoryApi extends BaseAPI {
    /**
     * Delete one or more learning types for a given agent/customer/counterparty/perspective.
     * @summary Delete one or more learnings
     * @param {MemoryApiDeleteMemoryLearningApiV1MemoryLearningsDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMemoryLearningApiV1MemoryLearningsDeletePost(requestParameters: MemoryApiDeleteMemoryLearningApiV1MemoryLearningsDeletePostRequest, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).deleteMemoryLearningApiV1MemoryLearningsDeletePost(requestParameters.deleteLearningRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve one or more learning types for a given agent/customer/counterparty/perspective.
     * @summary Get memory learnings
     * @param {MemoryApiGetMemoryLearningsApiV1MemoryLearningsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMemoryLearningsApiV1MemoryLearningsGet(requestParameters: MemoryApiGetMemoryLearningsApiV1MemoryLearningsGetRequest, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).getMemoryLearningsApiV1MemoryLearningsGet(requestParameters.agentName, requestParameters.counterpartyName, requestParameters.perspective, requestParameters.reconType, requestParameters.learningTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a single learning type for a given agent/customer/counterparty/perspective.
     * @summary Store or update a learning
     * @param {MemoryApiStoreMemoryLearningApiV1MemoryLearningsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storeMemoryLearningApiV1MemoryLearningsPost(requestParameters: MemoryApiStoreMemoryLearningApiV1MemoryLearningsPostRequest, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).storeMemoryLearningApiV1MemoryLearningsPost(requestParameters.storeLearningRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionsApi - axios parameter creator
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get latest non-deleted transactions for a job in CSV format. Pagination is optional.
         * @summary Get Transactions by Job
         * @param {string} jobId 
         * @param {number} [page] Page number (1-based). If not provided, returns all transactions.
         * @param {number} [limit] Number of transactions per page. If not provided, returns all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByJobApiV1JobsJobIdTransactionsGet: async (jobId: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getTransactionsByJobApiV1JobsJobIdTransactionsGet', 'jobId', jobId)
            const localVarPath = `/api/v1/jobs/{job_id}/transactions`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revert all transactions for a job to a specific version
         * @summary Revert All Transactions to Version
         * @param {string} jobId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost: async (jobId: string, versionNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost', 'jobId', jobId)
            // verify required parameter 'versionNumber' is not null or undefined
            assertParamExists('revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost', 'versionNumber', versionNumber)
            const localVarPath = `/api/v1/jobs/{job_id}/versions/{version_number}/revert`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"version_number"}}`, encodeURIComponent(String(versionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update transactions
         * @summary Update Transactions
         * @param {string} jobId 
         * @param {UpdateTransactionsRequest} updateTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransactionsApiV1JobsJobIdTransactionsUpdatePost: async (jobId: string, updateTransactionsRequest: UpdateTransactionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('updateTransactionsApiV1JobsJobIdTransactionsUpdatePost', 'jobId', jobId)
            // verify required parameter 'updateTransactionsRequest' is not null or undefined
            assertParamExists('updateTransactionsApiV1JobsJobIdTransactionsUpdatePost', 'updateTransactionsRequest', updateTransactionsRequest)
            const localVarPath = `/api/v1/jobs/{job_id}/transactions/update`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransactionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get latest non-deleted transactions for a job in CSV format. Pagination is optional.
         * @summary Get Transactions by Job
         * @param {string} jobId 
         * @param {number} [page] Page number (1-based). If not provided, returns all transactions.
         * @param {number} [limit] Number of transactions per page. If not provided, returns all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsByJobApiV1JobsJobIdTransactionsGet(jobId: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsByJobApiV1JobsJobIdTransactionsGet(jobId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.getTransactionsByJobApiV1JobsJobIdTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revert all transactions for a job to a specific version
         * @summary Revert All Transactions to Version
         * @param {string} jobId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost(jobId: string, versionNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost(jobId, versionNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update transactions
         * @summary Update Transactions
         * @param {string} jobId 
         * @param {UpdateTransactionsRequest} updateTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransactionsApiV1JobsJobIdTransactionsUpdatePost(jobId: string, updateTransactionsRequest: UpdateTransactionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransactionsApiV1JobsJobIdTransactionsUpdatePost(jobId, updateTransactionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionsApi.updateTransactionsApiV1JobsJobIdTransactionsUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionsApi - factory interface
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * Get latest non-deleted transactions for a job in CSV format. Pagination is optional.
         * @summary Get Transactions by Job
         * @param {TransactionsApiGetTransactionsByJobApiV1JobsJobIdTransactionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByJobApiV1JobsJobIdTransactionsGet(requestParameters: TransactionsApiGetTransactionsByJobApiV1JobsJobIdTransactionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTransactionsByJobApiV1JobsJobIdTransactionsGet(requestParameters.jobId, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Revert all transactions for a job to a specific version
         * @summary Revert All Transactions to Version
         * @param {TransactionsApiRevertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost(requestParameters: TransactionsApiRevertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransactionResponse>> {
            return localVarFp.revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost(requestParameters.jobId, requestParameters.versionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Update transactions
         * @summary Update Transactions
         * @param {TransactionsApiUpdateTransactionsApiV1JobsJobIdTransactionsUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransactionsApiV1JobsJobIdTransactionsUpdatePost(requestParameters: TransactionsApiUpdateTransactionsApiV1JobsJobIdTransactionsUpdatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateTransactionsResponse> {
            return localVarFp.updateTransactionsApiV1JobsJobIdTransactionsUpdatePost(requestParameters.jobId, requestParameters.updateTransactionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getTransactionsByJobApiV1JobsJobIdTransactionsGet operation in TransactionsApi.
 */
export interface TransactionsApiGetTransactionsByJobApiV1JobsJobIdTransactionsGetRequest {
    readonly jobId: string

    /**
     * Page number (1-based). If not provided, returns all transactions.
     */
    readonly page?: number

    /**
     * Number of transactions per page. If not provided, returns all transactions.
     */
    readonly limit?: number
}

/**
 * Request parameters for revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost operation in TransactionsApi.
 */
export interface TransactionsApiRevertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPostRequest {
    readonly jobId: string

    readonly versionNumber: number
}

/**
 * Request parameters for updateTransactionsApiV1JobsJobIdTransactionsUpdatePost operation in TransactionsApi.
 */
export interface TransactionsApiUpdateTransactionsApiV1JobsJobIdTransactionsUpdatePostRequest {
    readonly jobId: string

    readonly updateTransactionsRequest: UpdateTransactionsRequest
}

/**
 * TransactionsApi - object-oriented interface
 */
export class TransactionsApi extends BaseAPI {
    /**
     * Get latest non-deleted transactions for a job in CSV format. Pagination is optional.
     * @summary Get Transactions by Job
     * @param {TransactionsApiGetTransactionsByJobApiV1JobsJobIdTransactionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransactionsByJobApiV1JobsJobIdTransactionsGet(requestParameters: TransactionsApiGetTransactionsByJobApiV1JobsJobIdTransactionsGetRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getTransactionsByJobApiV1JobsJobIdTransactionsGet(requestParameters.jobId, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revert all transactions for a job to a specific version
     * @summary Revert All Transactions to Version
     * @param {TransactionsApiRevertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost(requestParameters: TransactionsApiRevertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPostRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).revertAllTransactionsToVersionApiV1JobsJobIdVersionsVersionNumberRevertPost(requestParameters.jobId, requestParameters.versionNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update transactions
     * @summary Update Transactions
     * @param {TransactionsApiUpdateTransactionsApiV1JobsJobIdTransactionsUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTransactionsApiV1JobsJobIdTransactionsUpdatePost(requestParameters: TransactionsApiUpdateTransactionsApiV1JobsJobIdTransactionsUpdatePostRequest, options?: RawAxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateTransactionsApiV1JobsJobIdTransactionsUpdatePost(requestParameters.jobId, requestParameters.updateTransactionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypesApi - axios parameter creator
 */
export const TypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new reconciliation type with name
         * @summary Create Type
         * @param {CreateTypeRequest} createTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeApiV1TypesPost: async (createTypeRequest: CreateTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTypeRequest' is not null or undefined
            assertParamExists('createTypeApiV1TypesPost', 'createTypeRequest', createTypeRequest)
            const localVarPath = `/api/v1/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing reconciliation type
         * @summary Edit Type
         * @param {string} typeId 
         * @param {EditTypeRequest} editTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTypeApiV1TypesTypeIdEditPost: async (typeId: string, editTypeRequest: EditTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('editTypeApiV1TypesTypeIdEditPost', 'typeId', typeId)
            // verify required parameter 'editTypeRequest' is not null or undefined
            assertParamExists('editTypeApiV1TypesTypeIdEditPost', 'editTypeRequest', editTypeRequest)
            const localVarPath = `/api/v1/types/{type_id}/edit`
                .replace(`{${"type_id"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available reconciliation types with pagination
         * @summary Get All Types
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Number of types per page
         * @param {string} [name] Type name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTypesApiV1TypesGet: async (page?: number, limit?: number, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific reconciliation type by ID
         * @summary Get Type by ID
         * @param {string} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeByIdApiV1TypesTypeIdGet: async (typeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('getTypeByIdApiV1TypesTypeIdGet', 'typeId', typeId)
            const localVarPath = `/api/v1/types/{type_id}`
                .replace(`{${"type_id"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypesApi - functional programming interface
 */
export const TypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new reconciliation type with name
         * @summary Create Type
         * @param {CreateTypeRequest} createTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTypeApiV1TypesPost(createTypeRequest: CreateTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Type>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTypeApiV1TypesPost(createTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypesApi.createTypeApiV1TypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing reconciliation type
         * @summary Edit Type
         * @param {string} typeId 
         * @param {EditTypeRequest} editTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editTypeApiV1TypesTypeIdEditPost(typeId: string, editTypeRequest: EditTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Type>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editTypeApiV1TypesTypeIdEditPost(typeId, editTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypesApi.editTypeApiV1TypesTypeIdEditPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available reconciliation types with pagination
         * @summary Get All Types
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Number of types per page
         * @param {string} [name] Type name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTypesApiV1TypesGet(page?: number, limit?: number, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTypesApiV1TypesGet(page, limit, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypesApi.getAllTypesApiV1TypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific reconciliation type by ID
         * @summary Get Type by ID
         * @param {string} typeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypeByIdApiV1TypesTypeIdGet(typeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Type>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTypeByIdApiV1TypesTypeIdGet(typeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypesApi.getTypeByIdApiV1TypesTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypesApi - factory interface
 */
export const TypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypesApiFp(configuration)
    return {
        /**
         * Create a new reconciliation type with name
         * @summary Create Type
         * @param {TypesApiCreateTypeApiV1TypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeApiV1TypesPost(requestParameters: TypesApiCreateTypeApiV1TypesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Type> {
            return localVarFp.createTypeApiV1TypesPost(requestParameters.createTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing reconciliation type
         * @summary Edit Type
         * @param {TypesApiEditTypeApiV1TypesTypeIdEditPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editTypeApiV1TypesTypeIdEditPost(requestParameters: TypesApiEditTypeApiV1TypesTypeIdEditPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Type> {
            return localVarFp.editTypeApiV1TypesTypeIdEditPost(requestParameters.typeId, requestParameters.editTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available reconciliation types with pagination
         * @summary Get All Types
         * @param {TypesApiGetAllTypesApiV1TypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTypesApiV1TypesGet(requestParameters: TypesApiGetAllTypesApiV1TypesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTypesResponse> {
            return localVarFp.getAllTypesApiV1TypesGet(requestParameters.page, requestParameters.limit, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific reconciliation type by ID
         * @summary Get Type by ID
         * @param {TypesApiGetTypeByIdApiV1TypesTypeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeByIdApiV1TypesTypeIdGet(requestParameters: TypesApiGetTypeByIdApiV1TypesTypeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Type> {
            return localVarFp.getTypeByIdApiV1TypesTypeIdGet(requestParameters.typeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTypeApiV1TypesPost operation in TypesApi.
 */
export interface TypesApiCreateTypeApiV1TypesPostRequest {
    readonly createTypeRequest: CreateTypeRequest
}

/**
 * Request parameters for editTypeApiV1TypesTypeIdEditPost operation in TypesApi.
 */
export interface TypesApiEditTypeApiV1TypesTypeIdEditPostRequest {
    readonly typeId: string

    readonly editTypeRequest: EditTypeRequest
}

/**
 * Request parameters for getAllTypesApiV1TypesGet operation in TypesApi.
 */
export interface TypesApiGetAllTypesApiV1TypesGetRequest {
    /**
     * Page number (1-based)
     */
    readonly page?: number

    /**
     * Number of types per page
     */
    readonly limit?: number

    /**
     * Type name
     */
    readonly name?: string
}

/**
 * Request parameters for getTypeByIdApiV1TypesTypeIdGet operation in TypesApi.
 */
export interface TypesApiGetTypeByIdApiV1TypesTypeIdGetRequest {
    readonly typeId: string
}

/**
 * TypesApi - object-oriented interface
 */
export class TypesApi extends BaseAPI {
    /**
     * Create a new reconciliation type with name
     * @summary Create Type
     * @param {TypesApiCreateTypeApiV1TypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTypeApiV1TypesPost(requestParameters: TypesApiCreateTypeApiV1TypesPostRequest, options?: RawAxiosRequestConfig) {
        return TypesApiFp(this.configuration).createTypeApiV1TypesPost(requestParameters.createTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing reconciliation type
     * @summary Edit Type
     * @param {TypesApiEditTypeApiV1TypesTypeIdEditPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editTypeApiV1TypesTypeIdEditPost(requestParameters: TypesApiEditTypeApiV1TypesTypeIdEditPostRequest, options?: RawAxiosRequestConfig) {
        return TypesApiFp(this.configuration).editTypeApiV1TypesTypeIdEditPost(requestParameters.typeId, requestParameters.editTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available reconciliation types with pagination
     * @summary Get All Types
     * @param {TypesApiGetAllTypesApiV1TypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllTypesApiV1TypesGet(requestParameters: TypesApiGetAllTypesApiV1TypesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return TypesApiFp(this.configuration).getAllTypesApiV1TypesGet(requestParameters.page, requestParameters.limit, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific reconciliation type by ID
     * @summary Get Type by ID
     * @param {TypesApiGetTypeByIdApiV1TypesTypeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTypeByIdApiV1TypesTypeIdGet(requestParameters: TypesApiGetTypeByIdApiV1TypesTypeIdGetRequest, options?: RawAxiosRequestConfig) {
        return TypesApiFp(this.configuration).getTypeByIdApiV1TypesTypeIdGet(requestParameters.typeId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhooksApi - axios parameter creator
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle webhook callback from Bedrock AgentCore with simple success/failure status
         * @summary AgentCore Webhook Callback
         * @param {string} jobId 
         * @param {string} jobType 
         * @param {AgentCoreWebhookCallbackRequest} agentCoreWebhookCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost: async (jobId: string, jobType: string, agentCoreWebhookCallbackRequest: AgentCoreWebhookCallbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost', 'jobId', jobId)
            // verify required parameter 'jobType' is not null or undefined
            assertParamExists('handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost', 'jobType', jobType)
            // verify required parameter 'agentCoreWebhookCallbackRequest' is not null or undefined
            assertParamExists('handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost', 'agentCoreWebhookCallbackRequest', agentCoreWebhookCallbackRequest)
            const localVarPath = `/api/v1/webhooks/jobs/{job_id}/type/{job_type}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"job_type"}}`, encodeURIComponent(String(jobType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCoreWebhookCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle webhook callback from Bedrock AgentCore with simple success/failure status
         * @summary AgentCore Webhook Callback
         * @param {string} jobId 
         * @param {string} jobType 
         * @param {AgentCoreWebhookCallbackRequest} agentCoreWebhookCallbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost(jobId: string, jobType: string, agentCoreWebhookCallbackRequest: AgentCoreWebhookCallbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost(jobId, jobType, agentCoreWebhookCallbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhooksApi - factory interface
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * Handle webhook callback from Bedrock AgentCore with simple success/failure status
         * @summary AgentCore Webhook Callback
         * @param {WebhooksApiHandleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost(requestParameters: WebhooksApiHandleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebhookResponse> {
            return localVarFp.handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost(requestParameters.jobId, requestParameters.jobType, requestParameters.agentCoreWebhookCallbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost operation in WebhooksApi.
 */
export interface WebhooksApiHandleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePostRequest {
    readonly jobId: string

    readonly jobType: string

    readonly agentCoreWebhookCallbackRequest: AgentCoreWebhookCallbackRequest
}

/**
 * WebhooksApi - object-oriented interface
 */
export class WebhooksApi extends BaseAPI {
    /**
     * Handle webhook callback from Bedrock AgentCore with simple success/failure status
     * @summary AgentCore Webhook Callback
     * @param {WebhooksApiHandleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost(requestParameters: WebhooksApiHandleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePostRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).handleAgentCoreWebhookCallbackApiV1WebhooksJobsJobIdTypeJobTypePost(requestParameters.jobId, requestParameters.jobType, requestParameters.agentCoreWebhookCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



